import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { likeCount, toggleSaved } from "../../features/Blog/BlogSlice";
import { fetchReatedBlogs } from "../../features/RelatedBlogs/RelatedBlogsSlice";
import { updateBlog } from "../../features/UpdateBlog/UpdateBlogSlice";

const DetailedSingleBlog = ({blog}) => {
  const dispatch = useDispatch();
  const { id, description, title, image, likes, tags, isSaved } =
    blog;

    useEffect(() => {
      dispatch(fetchReatedBlogs({id, tags}))
    },[dispatch, id, tags])

    const handleSaved = () => {
      dispatch(updateBlog({id, likes, isSaved : !isSaved}))
      dispatch(toggleSaved())
    }

    const handleLikes = () => {
      dispatch(updateBlog({id, likes: likes + 1, isSaved}))
      dispatch(likeCount())
    }

  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
        {tags.map((tag) => (
              <span key={tags.indexOf(tag)}>#{tag},</span>
            ))}
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button onClick={handleLikes} className="like-btn" id="lws-singleLinks">
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          <button onClick={handleSaved} className={isSaved ? "active save-btn" : "save-btn"} id="lws-singleSavedBtn">
            <i className="fa-regular fa-bookmark"></i> {isSaved ? 'Saved' : 'Save'} 
          </button>     
        </div>
        <div className="mt-6">
          <p>
            {description}
          </p>
        </div>
      </div>
    </main>
  );
};

export default DetailedSingleBlog;
